export const LOAD_REQUESTED = "ASSIGNABLE_USERS_SELECT/LOAD_REQUESTED";
export const LOAD_SUCCESS = "ASSIGNABLE_USERS_SELECT/LOAD_SUCCESS";
export const LOAD_FAIL = "ASSIGNABLE_USERS_SELECT/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadAssignableUsersSelect = data => ({ type: LOAD_REQUESTED, data });
export const successLoadAssignableUsersSelect = data => ({ type: LOAD_SUCCESS, data });
export const failLoadAssignableUsersSelect = data => ({ type: LOAD_FAIL, data });
